var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkOffOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.68 12.075-1.76-1.78h1.14q.422 0 .707.289.285.288.285.714 0 .251-.1.451a.9.9 0 0 1-.272.326m4.833 9.15a.93.93 0 0 1-.694.275.93.93 0 0 1-.694-.276L2.273 4.18A.96.96 0 0 1 2 3.478q0-.427.273-.702a.93.93 0 0 1 .694-.276q.42 0 .693.276L20.513 19.82a.96.96 0 0 1 .273.701q0 .427-.273.702M7.13 16.31q-2.056 0-3.507-1.466-1.45-1.467-1.45-3.547 0-1.729 1.041-3.083a4.83 4.83 0 0 1 2.677-1.78L7.725 8.29H7.13q-1.239 0-2.106.878-.868.877-.868 2.13 0 1.254.868 2.13.867.878 2.106.878h2.974q.421 0 .706.288t.285.715a.98.98 0 0 1-.285.714.95.95 0 0 1-.706.288zm1.983-4.01a.95.95 0 0 1-.707-.289.98.98 0 0 1-.285-.714q0-.426.285-.714a.95.95 0 0 1 .707-.288h.62L11.69 12.3zm9.417 2.807a1.06 1.06 0 0 1-.16-.752.88.88 0 0 1 .408-.626q.57-.428.905-1.053.334-.626.334-1.379 0-1.253-.867-2.13a2.85 2.85 0 0 0-2.107-.878H14.07a.95.95 0 0 1-.706-.288.98.98 0 0 1-.285-.714q0-.426.285-.715a.95.95 0 0 1 .706-.288h2.974q2.057 0 3.507 1.466Q22 9.218 22 11.298q0 1.229-.558 2.294-.557 1.065-1.549 1.767-.346.225-.743.163a.87.87 0 0 1-.62-.414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOffOutline);
export default __webpack_public_path__ + "static/media/link_off_outline.20c0cf9dfea581aeb1e2487a57d9d9e6.svg";
export { ForwardRef as ReactComponent };